import { render, staticRenderFns } from "./DealItem.vue?vue&type=template&id=4cf1a40e&scoped=true&"
import script from "./DealItem.vue?vue&type=script&lang=js&"
export * from "./DealItem.vue?vue&type=script&lang=js&"
import style0 from "./DealItem.vue?vue&type=style&index=0&id=4cf1a40e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1a40e",
  null
  
)

export default component.exports